import { BaseItem } from "../../interfaces/MediaAndContent";

const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

const BoxLogos = ({ displayedItems }: { displayedItems: BaseItem[] }) => {
    return (
        <>
            {displayedItems.map((item, index) =>
                item.url ? (
                    <a
                        key={index}
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-[180px] h-[124px] flex items-center justify-center rounded-lg p-6 shadow-md"
                    >
                        <img
                            src={`${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}${item.logo.replace("files/", "")}`}
                            alt={item.nombre}
                            className="max-w-full max-h-full object-contain"
                        />
                    </a>
                ) : (
                    <div
                        key={index}
                        className="w-[180px] h-[124px] flex items-center justify-center rounded-lg p-6 shadow-md"
                    >
                        <img
                            src={`${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}${item.logo.replace("files/", "")}`}
                            alt={item.nombre}
                            className="max-w-full max-h-full object-contain"
                        />
                    </div>
                )
            )}
        </>
    );
};

export default BoxLogos;